import axios from 'axios'

const ProductService = {
  async get (params = {}) {
    return axios.get('admin/suppliers', { params })
  },

  async import (params = {}) {
    return axios.post('admin/utilities/import-suppliers', params)
  },

  async sync (params = {}) {
    return axios.post('admin/utilities/sync-suppliers', params)
  },

  async post (params = {}) {
    return axios.post('admin/suppliers', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/suppliers/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/suppliers/${data.id}`, { data })
  }
}

export default ProductService
